module.exports = __webpack_public_path__ + "img/collapsible-product-grid.41298732.png";